import BenchlingConfig from 'BenchlingConfig';
import {pageLoadID} from 'ClientHeaders';

export function isCurrentClient(clientId: string): boolean {
  // We use the pageLoadID as the unique client identifier for realtime code
  return clientId === pageLoadID;
}

/**
 * Generates a resource realtime channel name for an API-identified resource.
 *
 * @param apiIdentifier the API identifier for the resource
 * @returns the channel name for the resource
 */
export function getRealtimeChannelNameForApiId(apiIdentifier: string): string {
  return `resource:${getNormalizedGlobalTenantIdentifier()}:${apiIdentifier}`;
}

/**
 * Builds a user channel name for the current user's API identifier.
 *
 * @param userId The user's API identifier
 * @returns The properly formatted user channel name
 */
export function getRealtimeChannelNameForUserId(userId: string): string {
  // Format the channel name as "user:{tenant_id}:{user_id}"
  // The tenant ID comes from the server and is part of the channel name
  return `user:${getNormalizedGlobalTenantIdentifier()}:${userId}`;
}

// TODO(BNCH-52491): Remove this helper method once colons have been removed from dev/staging tenant IDs.
function getNormalizedGlobalTenantIdentifier(): string {
  return BenchlingConfig.TENANT_ID.replace(':', '-');
}
